module.exports = __webpack_public_path__ + "static/media/painPoints.157ac0db.jpg";